import * as React from "react";
import throttle from "utils/throttle";
import { LinkBox, NavContainer, ArrowBox, ShowBox } from "./style";
import { TTextModule, TModuleProps } from "../../../services/playground";

import { TBannerItem } from "../../../services/banner";
import { getPxByRem } from "views/utils";

const NAVHEIGHT = 3.1; // 3rem

const arrowPoster =
  "https://t.rightinthebox.com/tights/litb/1qnwqe9h6x9c0_FipFPHV0jCuBeo8YBQgig1oJtL6m.png";

type NavigationText = Partial<TBannerItem & TTextModule>;
export interface NavigationProps extends TModuleProps {
  texts: NavigationText[];
  // 若存在title，则为title和nav的共同高度；若不存在title，则为nav的高度。两个高度皆为常数
  stickToTop?: number;
  navFixed?: boolean;
}

export interface ReactDom {
  rect: DOMRect | undefined;
  num: number;
}
const MNavigation = (props: NavigationProps) => {
  const { positionId, texts, navFixed, stickToTop = 0 } = props;
  const navRef: React.MutableRefObject<any> = React.useRef(null);
  const [showList, setShowList] = React.useState<boolean>(false);
  const [activeItem, setTabIndex] = React.useState<number>(0);
  const [scrollFixed, setScrollFixed] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (navFixed) {
      window.addEventListener("scroll", throttle(scrollObserver, 30));
    }
    return () => {
      window.addEventListener("scroll", throttle(scrollObserver, 30));
    };
  }, []);

  // 作用：判断nav是否需要吸顶 和 在nav fixed的情况下 滚动的时候，高亮对应的tab
  const scrollObserver = (event: Event) => {
    const target = event.target as Document;

    if (navFixed && navRef) {
      const scrollTop =
        (target ? target.documentElement.scrollTop : false) ||
        window.pageYOffset ||
        (target ? target.body.scrollTop : 0);
      if (scrollTop > navRef?.current?.offsetTop) {
        setScrollFixed(true);
        return;
      }
      setScrollFixed(false);
    }
  };

  const clickNavItem = (link: string = "", nextTab: number) => {
    setTabIndex(nextTab);
    const linkID: string = link.substr(1);
    const dom: any = document.getElementById(linkID);
    const hasSelfTop = navFixed ? getPxByRem(NAVHEIGHT) : 0;
    const top =
      dom?.getBoundingClientRect().top - getPxByRem(stickToTop) - hasSelfTop;

    window.scrollBy(0, top);

    setShowList(false);
  };

  const RenderItem = () => {
    return (texts || []).map((ele, index) => (
      <a
        key={`${ele.link}${index}`}
        data-index={activeItem}
        style={
          index === activeItem
            ? {
                fontWeight: 600,
                color: "#3e82f7",
                borderBottom: "2px solid",
              }
            : {}
        }
        onClick={() => clickNavItem(ele.link, index)}
      >
        {ele?.content || ele?.text}
      </a>
    ));
  };

  return (
    <section
      data-id={positionId}
      id={positionId}
      ref={navRef}
      style={{
        minHeight: `${NAVHEIGHT}rem`,
      }}
    >
      <NavContainer
        style={
          scrollFixed ? { position: "fixed", top: `${stickToTop}rem` } : {}
        }
      >
        {showList ? (
          <ShowBox>{RenderItem()}</ShowBox>
        ) : (
          <LinkBox>{RenderItem()}</LinkBox>
        )}
        <ArrowBox isUp={showList} onClick={() => setShowList(!showList)}>
          <img src={arrowPoster} alt="" />
        </ArrowBox>
      </NavContainer>
    </section>
  );
};
export default MNavigation;
